(function () {
  // Menú móvil
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Chips de categorías (Todo / categoría)
  document.querySelectorAll('[data-menu]').forEach(function (menu) {
    var chips = menu.querySelectorAll('[data-chip]');
    var groups = menu.querySelectorAll('[data-group]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = chip.getAttribute('data-chip');
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        groups.forEach(function (g) {
          g.hidden = target !== 'all' && g.getAttribute('data-group') !== target;
        });
      });
    });
  });

  // Producto: cantidad y variantes
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        qty.value = v;
      });
    });

    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var label = addBtn ? addBtn.textContent : '';
    var money = function (cents) { return 'S/ ' + (cents / 100).toFixed(2); };

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-opt]')) return;
      var chosen = [];
      form.querySelectorAll('[data-opt]:checked').forEach(function (i) {
        chosen[parseInt(i.getAttribute('data-opt'), 10)] = i.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? label : 'Agotado';
      }
    });
  });
})();
